<template>
  <div class="giftboxes-container">
    <div class="row">
      <div class="d-flex">
        <img
          src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Notre+se%CC%81lection.jpg"
          alt="Selections"
          class="img-giftbox pr-2"
        />
        <div class="d-flex flex-column justify-content-between align-items-start w-100 overflow-hidden">
          <div class="d-flex flex-column justify-content-start align-items-start w-100 overflow-hidden">
            <span class="merriweather-bold-p16 pl-2">Nos coffrets cadeaux</span>

            <div class="giftbox-section px-2 py-3">
              <div
                v-for="giftbox in giftboxes"
                :key="giftbox[0]"
                @click="goToLink(giftbox[1])"
              >
                <div
                  class="raleway-medi-p15 text-nowrap text-left item-link"
                >
                  {{ giftbox[0] }}
                </div>
              </div>
            </div>
          </div>
          <div class="align-items-center all-selections d-flex pl-2 pt-2 w-100 text-nowrap">
            <a @click="goToLink('/coffrets-cadeaux-entreprise')" class="hortense-btn-primary raleway-bold-p" target="_blank">Découvrir nos coffrets</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'GiftBoxList',
  data() {
    return {
      giftboxes: [
        ["Particuliers", "/coffrets-cadeaux"],
        ["Entreprises", "/coffrets-cadeaux-entreprise"],
        ["CSE & Collectivités", "/coffrets-cadeaux-cse"]
      ]
    }
  },
  methods: {
    goToLink(link) {
      window.open(link, '_blank');
    }
  }
}
</script>

<style scoped>
.giftboxes-container {
  top: 160px;
  left: 21px;
  gap: 32px;
  padding-top: 24px;
  padding-right: 32px;
  padding-bottom: 24px;
  padding-left: 32px;

  .img-giftbox {
    width: 220px;
    height: 289px;
    object-fit: cover;
  }

  .giftbox-section {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 30px;

    .item-link {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .raleway-bold-16{
    font-family: 'Raleway';
    font-weight: 700;
    font-size: 16px;
  }

  @media screen and (max-width: 1400px) {
    .hortense-btn-primary {
      padding: 16px 20px;
    }
    
  }
}
</style>